




import Vue from 'vue';
import MaterialDbList from '@/components/material-db/material-db-list.component.vue';

export default Vue.extend({
  components: {
    'material-db-list': MaterialDbList,
  },
});
